import { PLATFORM_RULES } from "../worker/business-config";

// The same brand marks as the report's channel cards and the Planning board
// (public/platforms/<platformId>.svg), so a platform looks identical everywhere.
const logoFile = (platform: string): string | null => {
  const name = platform.toLowerCase();
  if (name.includes("facebook") || name.includes("instagram")) return "meta";
  return PLATFORM_RULES.find((rule) => name.includes(rule.id) || name.includes(rule.label.toLowerCase()))?.id ?? null;
};

export function PlatformLogo({ platform }: { platform: string }) {
  const file = logoFile(platform);
  return file
    ? <img className={`platform-logo platform-logo--${file}`} src={`/platforms/${file}.svg`} alt="" aria-hidden="true" />
    : <span className="platform-logo platform-logo--generic" aria-hidden="true" />;
}
